















import Vue from "vue"
import type { ConfigurationProfileSummary } from "@/datasource/chargers"
import datasource from "@/datasource"

export default Vue.extend({
  props: {
    value: {
      type: [String, Object, Array],
      default: null,
    },

    returnId: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: true,
    },

    multiple: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: true,
      records: [] as ConfigurationProfileSummary[],
    }
  },

  computed: {
    modified: {
      get(): ConfigurationProfileSummary {
        return this.value
      },

      set(
        value:
          | ConfigurationProfileSummary
          | ConfigurationProfileSummary[]
          | string
          | string[]
      ): void {
        this.$emit("input", value)
      },
    },
  },

  created() {
    this.loadData()
  },

  methods: {
    async loadData() {
      this.loading = true
      const result = await datasource.chargers.listConfigurationProfiles()
      if (result instanceof Error) {
        console.error(result)
        return
      } else {
        this.records = result
        if (!this.clearable && !this.multiple) {
          this.modified ||= this.records[0]
        }
      }
      this.loading = false
    },
  },
})
